import {useEventsSearch} from '@domain/shifthandover'
import {
  ShiftEventsSortBy,
  SortOrder,
  ShiftQuickSelectSlots,
  ShiftEventCategory,
  TimeZone,
  Shift
} from '@hconnect/common/types'
import {FilterOptions} from '@widgets/shift-event-filters'
import moment from 'moment-timezone'
import {useMemo} from 'react'

const PAGE_NUMBER = 0
const ITEMS_PER_PAGE = 100
const SLOT: ShiftQuickSelectSlots = 'pastShift'
const CATEGORIES: ShiftEventCategory[] = [
  ShiftEventCategory.Mechanical,
  ShiftEventCategory.Electrical
]

type UseMechanicalElectricalCockpitEventsParams = {
  plantId: string
  timezone: TimeZone
  shifts: Shift[]
}

export const useMechanicalElectricalCockpitEvents = ({
  plantId,
  timezone,
  shifts
}: UseMechanicalElectricalCockpitEventsParams) => {
  const filter: FilterOptions = {timeRange: SLOT, category: CATEGORIES}
  // TODO: refactor to usePlantNow hook once it's extracted
  const getPlantNow = useMemo(() => () => moment().tz(timezone), [timezone])
  const hasShifts = shifts.length > 0

  return useEventsSearch(
    {
      plantId,
      timezone,
      shifts,
      getPlantNow,
      input: filter,
      sortBy: ShiftEventsSortBy.Details,
      sortOrder: SortOrder.Descending,
      pageNumber: PAGE_NUMBER,
      itemsPerPage: ITEMS_PER_PAGE
    },
    {
      enabled: hasShifts
    }
  )
}
